export interface Zone {
  id: number;
  user_id: number;
  name: string;
  x_min: number;
  y_min: number;
  x_max: number;
  y_max: number;
  eviction_timeout_sec: number;
  expires_at: string | null; // null = free/permanent
  is_free: boolean;
  amount_rub: number;
  created_at: string;
}

/** Returns true when the zone is currently active. */
export function isZoneActive(zone: Zone): boolean {
  if (zone.is_free) return true;
  if (!zone.expires_at) return false;
  return new Date(zone.expires_at) > new Date();
}
